import { inject, Injectable } from "@angular/core";
import { TaxesTrackingModel } from "@modules/taxes/domain/entities/taxes-tracking.model";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable()
export class TaxesTrackerFacade {
	private readonly rudderstackService = inject(RudderstackService);

	public tracker(model: TaxesTrackingModel, sliceNumber?: number): void {
		this.rudderstackService.track({
			name: model.name,
			properties: {
				screen_it_happened_on: model.location,
				slice: sliceNumber + 1
			}
		});
	}
}
